import { Container, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import { CustomButton, LetterSpacedHeading } from 'components/common';

// const StyledHeading = styled('h1')(({ theme }) => ({
//   background: '-webkit-linear-gradient(#008B5E 0%, #006041 100%)',
//   // '-webkit-background-clip': 'text',
//   WebkitBackgroundClip: 'text',
//   color: 'rgba(0,0,0,0)',
//   textAlign: 'center',
//   fontSize: 74,
//   fontWeight: 'bold',
//   lineHeight: '90px',
//   margin: 0,
//   [theme.breakpoints.down('sm')]: {
//     fontSize: 35,
//     lineHeight: 1.4,
//   },
// }));

const StyledContainer = styled(Container)(({ theme }) => ({
  backgroundColor: 'rgba(218, 255, 243, 1)',
  borderRadius: '10px',
  padding: '53px 0 60px',
  textAlign: 'center',
  '& a': {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: 'rgb(0, 139, 94)',
  },
  // [theme.breakpoints.down('sm')]: {
  //   marginLeft: 10,
  //   marginRight: 10,
  // },
}));

export const WeAreHiring = () => {
  return (
    <Box
      sx={{
        mx: {
          xs: 2,
          sm: 0,
        },
      }}
    >
      <StyledContainer>
        <LetterSpacedHeading component="h2">WE ARE HIRING</LetterSpacedHeading>
        <Typography
          component="p"
          sx={{
            // p: '23px 0 29px',
            fontSize: {
              xs: 16,
              lg: 20,
            },
            p: {
              xs: '23px 20px 29px',
              md: '23px 0 29px',
            },
          }}
          // fontSize={20}
          lineHeight="30px"
          whiteSpace="break-spaces"
        >
          Reshape fundraising in India with us.
          <br />
          We are always eager to hire fresh talent.
          <br />
          Email the HR Team at{' '}
          <a href="mailto:career@podworld.in">career@podworld.in</a> for
          details.
        </Typography>
        <a href="mailto:career@podworld.in">
          <CustomButton
            sx={{ fontSize: 20, width: 248, height: 62 }}
            variant="contained"
            disableElevation
          >
            I am Interested
          </CustomButton>
        </a>
      </StyledContainer>
    </Box>
  );
};
